import { Duration } from 'ht-sdk/std';

/**
 * Variables to tweak gameplay
 */
export const Vars = {
	sessionSaveDebounceTime: Duration.seconds(5),

	minSystemDamage: 0,
	maxSystemDamage: 100,

	/** System damage when the session starts */
	defaultSystemDamage: 0,
	/** Damage added to the system when a room fails */
	systemDamageForFailedRoom: 6,
	/** Damage reduced to the system when a room is repaired */
	systemReduceDamageForRepairedRoom: 6,
	/** Points added to the team score when a room is repaired */
	pointsForRepairedRoom: 10,
	/** Points added to the team score when a room is repaired */
	pointsForBonusCode: 6,

	gameDuration: Duration.minutes(45),
	roomStartupDurationMin: 5,
	roomStartupDurationMax: 10,
	connectionDuration: Duration.minutes(30),

	/**
	 * maximum number of times the room repair time can be extended,
	 * after that it will fail
	 */
	maxTimeExtendCount: 9,
	/** Points deduced from the room score for each time the repair time is extended */
	timeExtendPenaltyPoints: 1,
	/** Amount of time to add every time the repair time is extended */
	timeExtendDuration: Duration.minutes(1),
};
